module.exports = __webpack_public_path__ + "img/bfc87811841739e8eda8ea28259a0689.png";